import { render, staticRenderFns } from "./latest-scans.vue?vue&type=template&id=e0a41f90&scoped=true"
import script from "./latest-scans.vue?vue&type=script&lang=js"
export * from "./latest-scans.vue?vue&type=script&lang=js"
import style0 from "./latest-scans.vue?vue&type=style&index=0&id=e0a41f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a41f90",
  null
  
)

export default component.exports